import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import DataTable from "../../component/DataTable";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AddExperience from "./AddExperience";
import EditExperience from "./EditExperience";

const listEndpoint = ApiEndpoints.exp.List;
const deleteEndpoint = ApiEndpoints.exp.Delete;
const tableHeader = ["Date","Name"];
const tbody = ["createdAt","title"];

const dataFetch = async (setData) => {
  try {
    const response = await ApiRequest("GET", listEndpoint);
    const result = response.experiences;
    setData(result);
  } catch (error) {
    console.log(error);
  }
};

export default function Experience() {

  const [data, setData] = useState([]);
  const [locId, setLocId] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modaleditShow, setModalEditShow] = useState(false);

  useEffect(() => {
    dataFetch(setData);
  }, []);

  // const handleDelete = async (location_id) => {
  //   const payload = { location_id };
  //   try {
  //     const response = await ApiRequest("POST", deleteEndpoint, payload);
  //     toast.success(response.message);
  //     dataFetch();
  //   } catch (error) {
  //     console.error("Error deleting author:", error);
  //   }
  // };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / Experience'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>
  
    <div className="add-btn-section">
      <Link className="admin-add-btn" onClick={() => setModalShow(true)}>Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        setModalShow={setModalEditShow}
        setId = {setLocId}
        // onDelete={handleDelete}
      />
    </div>

    <AddExperience show={modalShow} onHide={() => setModalShow(false)}/>
    <EditExperience show={modaleditShow} locId ={locId} onHide={() => setModalEditShow(false)}/>
    </>
  )
}
